import React, { Fragment } from "react";
import { connect } from "react-redux";
import Scroll from "react-scroll";
import Contentify from "../../content/Contentify";
import QueryWithTwoOptions from "../shared/QueryWithTwoOptions";
import { updateIsNewClaimAndRelatedProperties, updateMakeAClaimAction } from "./../../actions/makeAClaim/MakeAClaimActions";
import Store from "./../../content/Store";
import { IS_NEW_CLAIM_CONDITION_CONTENT,NISSAN,BANK_OF_AMERICA,AGE_SIXTEEN,AGE_SEVENTEEN } from "./Constants";
import AreYouThePatient from "./AreYouThePatient";

export const IsNewClaimCondition = ({
  content,
  updateIsNewClaimAndRelatedProperties,
  isNewClaim,
  isThePatient,
  groupNumber,
  updateMakeAClaimAction,
  Members
}) => (
  <Fragment>
    {ageCheck(Members)}
    {isThePatient === false && (groupNumber !== BANK_OF_AMERICA || groupNumber !== NISSAN || ageFlag === false) && (
      <div className="hbsTop">
        <AreYouThePatient />
      </div>)}

    {isThePatient === true && (groupNumber === BANK_OF_AMERICA || groupNumber === NISSAN || ageFlag === true) && (
      <div className="hbsTop">
        <AreYouThePatient />
      </div>)}
    <div className="hbsTop"></div>
    <QueryWithTwoOptions
      query={content.isExistingClaimQuestion}
      option2Label={content.isExistingClaimChoice2}
      option1Label={content.isExistingClaimChoice1}
      tooltipContent={content.isExistingClaimQuestionTooltip}
      option1OnClickHandler={() => {
        updateIsNewClaimAndRelatedProperties(false);
        updateMakeAClaimAction("requiresAuthorisation", null);
        scrollToName();
      }}
      option2OnClickHandler={() => {
        updateIsNewClaimAndRelatedProperties(true);
        updateMakeAClaimAction("requiresAuthorisation", null);

        scrollToName();
      }}
      buttonType="transversalButton"
      optionTwoIsSelected={isNewClaim}
    />
  </Fragment>
);

var ageFlag = false;

function ageCheck(members) {
  if (members != null) {
    if (members.length > 0) {
      for (var i = 0; i < members.length; i++) {
        if (members[i].IsLoggedInMember === true) {
          var today = new Date();
          var birthDate = new Date(members[i].DateOfBirth);
          var age = today.getFullYear() - birthDate.getFullYear();
          var m = today.getMonth() - birthDate.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
          }
          if (age === AGE_SIXTEEN || age === AGE_SEVENTEEN) {
            ageFlag = true;
          }

        }
        else {
          ageFlag = false;
        }
      }
    }
  }
}

function scrollToName() {
  Scroll.scroller.scrollTo(IS_NEW_CLAIM_CONDITION_CONTENT, {
    duration: 750,
    smooth: true
  });
}

IsNewClaimCondition.content = Store.IsNewClaimCondition;

export const mapStateToIsNewClaimCondition = ({ makeAClaimReducer, policyReducer }) => (
  {
    isNewClaim: makeAClaimReducer.isNewClaim,
    isThePatient: makeAClaimReducer.isThePatient,
    groupNumber: policyReducer.selectedPolicy.GroupNumber,
    Members: policyReducer.selectedPolicy.Members
  });

export default connect(mapStateToIsNewClaimCondition, {
  updateIsNewClaimAndRelatedProperties,
  updateMakeAClaimAction
})(Contentify(IsNewClaimCondition));
